

import api from "../utils/axios";

export const getContents = async () => {
    const response = await api.get("/contents");

    return response.data;
};

export const getContent = async (slug) => {
    const response = await api.get(`/contents/${slug}`);

    return response.data;
};